import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";

export function useUsername() {
  const username = useQuery(api.account.getUsername);
  return {
    username,
    isLoading: username === undefined,
    hasUsername: !!username,
  };
}
